module.exports = __webpack_public_path__ + "img/plus.415c5915.svg";